import { ORIGEN_LEAD_VALUES } from '../../config'

export function setOriginLeadCMB() {
  const ELEMENTS = {
    REQUEST_BUDGET_HEADER: document.querySelectorAll(
      '[aria-label="Pedir Presupuesto"]'
    ),
    REQUEST_BUDGET_CTA: document.querySelectorAll(
      '[id^="cta_landing_formulario_"]'
    ),
    REQUEST_BUDGET_CTA_2: document.querySelectorAll(
      '[id^="cta_web_formulario"]'
    ),
    CALL_YOU_CTA_MOBILE: document.getElementById('dmvText')
  }

  window.originLeadValue = ''

  const setTagFromElements = ({ elements, value1, value2 }) => {
    if (elements.length > 0) {
      elements.forEach((element, i) => {
        element?.addEventListener('click', () => {
          if (i === 0) {
            window.originLeadValue = value1
          } else {
            window.originLeadValue = value2
          }
        })
      })
    }
  }

  /**
   * CALLME HEADER DESKTOP & CALLME HEADER MOBILE
   */
  setTagFromElements({
    elements: ELEMENTS.REQUEST_BUDGET_HEADER,
    value1: ORIGEN_LEAD_VALUES.CALLME_HEADER_DESKTOP,
    value2: ORIGEN_LEAD_VALUES.CALLME_HEADER_MOBILE
  })

  /**
   * CALLME DESKTOP STICKY & CALLME DESKTOP BOTÓN CMS
   */
  setTagFromElements({
    elements: ELEMENTS.REQUEST_BUDGET_CTA,
    value1: ORIGEN_LEAD_VALUES.CALLME_DESKTOP_STICKY,
    value2: ORIGEN_LEAD_VALUES.CALLME_DESKTOP_BOTON_CMS
  })

  /**
   * CALLME DESKTOP STICKY & CALLME DESKTOP BOTÓN CMS (otra variante de botón)
   */
  setTagFromElements({
    elements: ELEMENTS.REQUEST_BUDGET_CTA_2,
    value1: ORIGEN_LEAD_VALUES.CALLME_DESKTOP_STICKY,
    value2: ORIGEN_LEAD_VALUES.CALLME_DESKTOP_BOTON_CMS
  })

  /**
   * * CALLME MOBILE CTA
   */
  ELEMENTS.CALL_YOU_CTA_MOBILE?.addEventListener('click', () => {
    window.originLeadValue = ORIGEN_LEAD_VALUES.CALLME_MOBILE_CTA
  })
}
